import './StripCalendarEventCapsule.scss';
import { getCapsuleClassName, getCarryOverEventColor, getEventColor } from '../../../pages/MyBlockMonth/myBlockMonthHelper';
import CalendarReleaseCapsule from '../../CalendarReleaseCapsule/CalendarReleaseCapsule';
import { CALENDAR_TYPE } from '../../../constants/myBlockMonth';

const StripCalendarEventCapsule = ({blockDate, calendarElementWidth, event}) => {

    /**
     * @returns the background color of the capsule dependent on the activity type, of it is a carryOver, calculate the gradient percentage
     */
     const getCapsuleBackground = () => {
        if(event.carryIn) {
            const carryInGradientPercentage = (calendarElementWidth/ event.width)*100;
            return `linear-gradient(90deg, ${getCarryOverEventColor(event.activityType)} ${carryInGradientPercentage}%, ${getEventColor(event.activityType)} 0%)`;
        }
        else if(event.carryOut) {
            const carryOutNonGradientPercentage = 100 - (calendarElementWidth/ event.width)*100
            return `linear-gradient(90deg, ${getEventColor(event.activityType)} ${carryOutNonGradientPercentage}%, ${getCarryOverEventColor(event.activityType)} 0%)`;
        }
        else return getEventColor(event.activityType);
    }

    return (
        <div className={getCapsuleClassName(event, CALENDAR_TYPE.STRIP, blockDate)} style={{background: getCapsuleBackground()}}>
            {event.release && 
                <CalendarReleaseCapsule 
                    blockDate={blockDate} 
                    calendarElementWidth={calendarElementWidth} 
                    calendarType={CALENDAR_TYPE.STRIP} 
                    event={event}
                />
            }
        </div>
    )
}

export default StripCalendarEventCapsule;